export interface KpiMetricMeta {
  group: string;
  format: 'number' | 'currency' | 'decimal' | 'percent';
}

export const STORE_KPI_CATALOG: Record<string, KpiMetricMeta> = {
  orderCount: { group: 'orders', format: 'number' },
  completedOrders: { group: 'orders', format: 'number' },
  processingOrders: { group: 'orders', format: 'number' },
  paidIncompleteOrders: { group: 'orders', format: 'number' },
  revenue: { group: 'revenue', format: 'currency' },
  aov: { group: 'revenue', format: 'currency' },
  medianOrderValue: { group: 'revenue', format: 'currency' },
  maxOrderValue: { group: 'revenue', format: 'currency' },
  totalItemsSold: { group: 'items', format: 'number' },
  avgItemsPerOrder: { group: 'items', format: 'decimal' },
  tradingDays: { group: 'trading', format: 'number' },
  avgOrdersPerTradingDay: { group: 'trading', format: 'decimal' },
  avgRevenuePerTradingDay: { group: 'trading', format: 'currency' },
  identifiedCustomers: { group: 'trading', format: 'number' },
  guestCheckouts: { group: 'trading', format: 'number' },
  periodGrowth: { group: 'extra', format: 'percent' },
  returnsVoids: { group: 'extra', format: 'currency' },
};

export const NOGLETAL_KEYS = [
  'orderCount',
  'completedOrders',
  'processingOrders',
  'paidIncompleteOrders',
  'revenue',
  'aov',
  'medianOrderValue',
  'maxOrderValue',
  'totalItemsSold',
  'avgItemsPerOrder',
  'tradingDays',
  'avgOrdersPerTradingDay',
  'avgRevenuePerTradingDay',
  'identifiedCustomers',
  'guestCheckouts',
];

export const NOGLETAL_GROUPS = [
  {
    key: 'orders',
    metrics: ['orderCount', 'completedOrders', 'processingOrders', 'paidIncompleteOrders'],
  },
  {
    key: 'revenue',
    metrics: ['revenue', 'aov', 'medianOrderValue', 'maxOrderValue'],
  },
  {
    key: 'items',
    metrics: ['totalItemsSold', 'avgItemsPerOrder'],
  },
  {
    key: 'trading',
    metrics: [
      'tradingDays',
      'avgOrdersPerTradingDay',
      'avgRevenuePerTradingDay',
      'identifiedCustomers',
      'guestCheckouts',
    ],
  },
];

export const TILE_CATALOG_KEYS = Object.keys(STORE_KPI_CATALOG);

export const DEFAULT_STORE_TILE_KEYS = [
  'revenue',
  'orderCount',
  'aov',
  'totalItemsSold',
  'avgRevenuePerTradingDay',
  'periodGrowth',
  'identifiedCustomers',
  'returnsVoids',
];

export const DEFAULT_CHAIN_TILE_KEYS = [...DEFAULT_STORE_TILE_KEYS];

export const MAX_TILES = 8;
export const MAX_SAVED_VIEWS = 5;

export const TILE_ICONS: Record<string, string> = {
  orderCount: 'shopping-cart-outline',
  completedOrders: 'checkmark-circle-2-outline',
  processingOrders: 'sync-outline',
  paidIncompleteOrders: 'alert-circle-outline',
  revenue: 'credit-card-outline',
  aov: 'trending-up-outline',
  medianOrderValue: 'bar-chart-outline',
  maxOrderValue: 'arrow-upward-outline',
  totalItemsSold: 'cube-outline',
  avgItemsPerOrder: 'layers-outline',
  tradingDays: 'calendar-outline',
  avgOrdersPerTradingDay: 'activity-outline',
  avgRevenuePerTradingDay: 'pie-chart-outline',
  identifiedCustomers: 'people-outline',
  guestCheckouts: 'person-outline',
  periodGrowth: 'trending-up-outline',
  returnsVoids: 'undo-outline',
};
